<template>
  <view-wrapper
    prefix="Configure "
    name="Label"
    path="labels"
    saveText="Save"
    :saveFunc="createLabel"
    :hasChangesBeenMade="hasChangesBeenMade"
    :validation="validation"
    :loading="loading"
    :back-text="'Back to labels'"
  >
    <grafokett-button
      class="mt-2 mb-6 mr-4 big primary white"
      @click="modalInactivate = !modalInactivate"
      >{{
        currentLabel && currentLabel.disabled ? "Activate" : "Inactivate"
      }}
      label</grafokett-button
    >
    <grafokett-button
      class="mt-2 mb-6 big primary white"
      @click="gotoToArticleWithPresets()"
      >Create article from label</grafokett-button
    >

    <div
      :class="
        currentLabel && currentLabel.disabled
          ? 'pointer-events-none opacity-75'
          : ''
      "
    >
      <wrapper
        :checkForChildFocused="true"
        class="p-5 pt-10 mb-3"
        :focus="labelname !== ''"
      >
        <grafokett-input
          class="w-96"
          v-model="labelname"
          :editable="true"
          labelPlaceholder="Label name"
        />
      </wrapper>

      <wrapper
        v-if="features && features.labelVersionControlEnabled === true"
        class="mb-4"
      >
        <div>
          <router-link
            class="font-bold text-highlight"
            :to="`/qa/labels/${this.$route.params.id}/details`"
            >Go to label version</router-link
          >
        </div>
      </wrapper>

      <wrapper
        v-if="
          features &&
            features.labelVersionControlEnabled === false &&
            subscriptionType !== 'Free'
        "
        class="mb-4"
        :focus="file !== undefined || !changeFile"
      >
        <div>
          <div class="relative py-40" v-if="!file && changeFile">
            <div class="absolute inset-0 flex flex-col p-4">
              <p class="mt-0">Upload file (.nlbl)</p>
              <Dropzone
                :multiple="false"
                @filesAdded="onFilesAdded"
                accept=".nlbl"
              >
                Add file
              </Dropzone>
              <div class="w-full">
                <grafokett-button
                  class="float-right mt-4 small"
                  @click="
                    () => {
                      changeFile = false;
                    }
                  "
                  >Cancel</grafokett-button
                >
              </div>
            </div>
          </div>
          <div class="p-4 rounded bg-primary-light" v-else>
            <span>{{
              file === undefined ? "File not changed" : file.name
            }}</span>
            <grafokett-button
              class="float-right small"
              @click="
                () => {
                  changeFile = true;
                  file = undefined;
                }
              "
              >Change file</grafokett-button
            >
          </div>
          <grafokett-button
            class="flex content-center w-40 mt-4 light"
            @click="uploadFiles"
            v-if="file"
          >
            <i class="p-1 upload-symbol" />
            <span class="flex-1 inline-block p-1 text-white">Upload</span>
          </grafokett-button>
        </div>
      </wrapper>

      <wrapper
        :checkForChildFocused="true"
        class="p-5 mb-3"
        :focus="labelname !== ''"
      >
        <p>Bind variables to variable data sources</p>
        <div
          class="flex flex-col w-full"
          v-for="(variable, index) in variables"
          :key="componentKey + index"
        >
          <div class="flex">
            <p class="flex-1">{{ variable.name }}</p>
            <p v-if="index === 0">Allow users to edit</p>
          </div>
          <div class="flex items-center w-full">
            <div class="flex-1">
              <drop-down
                placeholder="Select datatype"
                :value="{
                  variable,
                  dataType:
                    variable.dataType === 'Unknown' ? '' : variable.dataType,
                }"
                valueProperty="dataType"
                searchProp="dataType"
                :options="dataTypeOptions"
                @input="updateVariableDataType($event, variables[index])"
              >
                {{ variable.dataType }}
              </drop-down>
            </div>
            <grafokett-input
              v-if="variable.dataType !== 'media-ref' && variable.dataType !== 'counter'"
              :type="variable.dataType"
              class="flex-1 ml-4"
              :editable="true"
              v-model="variable.value"
              :labelPlaceholder="
                variable.dataType === 'toggle' ? '' : 'Default value'
              "
            />
            <div
              class="flex items-center flex-1 ml-4"
              v-if="variable.dataType === 'counter'"
            >
              <drop-down
                class="flex-1"
                placeholder="Select counter"
                :value="getSelectedCounter(variable.counterId)"
                value-property="name"
                search-prop="name"
                :options="counters"
                @input="variable.counterId = $event ? $event.id : null"
              />
            </div>
            <div
              class="flex items-center flex-1 ml-4"
              v-if="variable.dataType === 'media-ref'"
            >
              <span v-if="variable.value">{{ variable.value }}</span>
              <button
                @click="openMediaLibraryModal(variable)"
                type="button"
                class="flex items-center px-2 py-1 ml-auto font-semibold bg-transparent border-solid rounded-lg cursor-pointer border-highlight text-highlight"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="w-6 h-6 mr-2"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                  />
                </svg>
                Template
              </button>
            </div>
            <i
              @click="variable.editable = !variable.editable"
              class="flex-none p-3 my-auto ml-4 lock-symbol"
              :class="variable.editable ? '' : 'locked'"
            />
          </div>
        </div>
      </wrapper>
      <assign-groups
        class="mb-5"
        text="Assign group to this label"
        :label="currentLabel"
        :groups="availableGroups"
        :subscriptionType="subscriptionType"
        v-model="groups"
        @groupAdded="addGroup"
        @removeGroup="removeGroup"
        @printerAdded="addPrinter"
        @printerRemoved="removePrinter"
      />

      <wrapper
        :checkForChildFocused="true"
        class="p-5 mb-3"
        v-if="currentLabel"
      >
        <p>Counter settings</p>
        <div class="flex items-center mb-3">
          <checkbox class="m-1" v-model="currentLabel.useCounter" />
          <div
            class="cursor-pointer select-none"
            @click="currentLabel.useCounter = !currentLabel.useCounter"
          >
            <span class="pl-2 ">Use Counter</span>
          </div>
        </div>
        <div
          v-if="
            currentLabel && currentLabel.serialNumber && currentLabel.useCounter
          "
        >
          <grafokett-input
            class="mr-4 w-96"
            :editable="true"
            v-model="currentLabel.serialNumber.lastGeneratedValue"
            labelPlaceholder="Last generated value"
          />
          <grafokett-input
            class="w-96"
            :editable="true"
            v-model="currentLabel.serialNumber.serialNumberLength"
            labelPlaceholder="Zero padded length"
          />
        </div>
      </wrapper>

      <wrapper :checkForChildFocused="true" class="p-5 pt-10 mb-3">
        <p>Print settings</p>
        <grafokett-input
          class="w-96"
          :editable="true"
          v-model="numberOfIdenticalCopies"
          labelPlaceholder="Number of identical copies"
        />
        <div class="flex items-center pt-2">
          <checkbox class="m-1" v-model="useA4Pdf" />
          <div
            class="cursor-pointer select-none"
            @click="useA4Pdf = useA4Pdf ? false : true"
          >
            <span class="block pl-2">Use A4 PDF</span>
          </div>
        </div>
      </wrapper>
    </div>

    <modal
      v-if="labelActiveStatusChanged"
      :type="'success'"
      :heading="computeActivationStatus(true, true)"
      :description="
        `Label has been successfully ${computeActivationStatus(true, false)}`
      "
    >
      <template v-slot:close>
        <div />
      </template>
    </modal>

    <Loading
      v-if="labelVariabelsChanged"
      heading="Uploading..."
      description="Please wait"
    />

    <modal
      v-if="modalInactivate"
      @close="modalInactivate = !modalInactivate"
      :type="'warning'"
      :heading="computeActivationStatus(false, true)"
      :descriptions="[
        `Your are about to ${computeActivationStatus(false, true)} ${
          currentLabel.name
        }.`,
        `Are you sure you want to ${computeActivationStatus(false, true)}?`,
      ]"
    >
      <template v-slot:buttons>
        <div>
          <grafokett-button
            class="bg-white big border-primary text-primary"
            @click="toggleActivateStatusOnLabel"
            >Yes, {{ computeActivationStatus(false, false) }}</grafokett-button
          >
          <grafokett-button
            class="ml-2 big bg-primary text-textcolor"
            @click="modalInactivate = !modalInactivate"
            >Go back</grafokett-button
          >
        </div>
      </template>
    </modal>
    <media-ref-modal
      :folders="folders"
      :variables="variables"
      :variable="selectedVariable"
      v-if="isMediaLibraryModalOpen"
      @close="isMediaLibraryModalOpen = false"
      @saveSelection="saveMediaRefSelection($event)"
    ></media-ref-modal>
  </view-wrapper>
</template>

<script>
import GrafokettButton from "../components/forms/Button.vue";
import GrafokettInput from "../components/forms/Input.vue";
import AssignGroups from "../components/datacomponents/AssignGroups";
import Modal from "../components/Modal";
import DropDown from "../components/forms/DropDown.vue";
import Checkbox from "../components/forms/Checkbox";
import Dropzone from "../components/Dropzone";
import Loading from "../components/Loading";
import MediaRefModal from "../components/MediaRefModal.vue";

export default {
  components: {
    GrafokettButton,
    Modal,
    GrafokettInput,
    AssignGroups,
    DropDown,
    Checkbox,
    Dropzone,
    Loading,
    MediaRefModal,
  },
  data() {
    return {
      labelname: "",
      numberOfIdenticalCopies: null,
      useA4Pdf: false,
      changeFile: false,
      file: undefined,
      options: [],
      groups: [],
      variables: [],
      currentLabel: undefined,
      bindings: [],
      componentKey: 0,
      existingGroups: [],
      printers: [],
      groupsToBeAdded: [],
      groupsToBeRemoved: [],
      loading: false,
      modalInactivate: false,
      labelActiveStatusChanged: false,
      labelVariabelsChanged: false,
      newVariables: [],
      features: [],
      subscriptionType: "",
      folders: [],
      isMediaLibraryModalOpen: false,
      selectedVariable: null,
    };
  },
  async mounted() {
    this.getLabel();
  },
  computed: {
    availableGroups() {
      return this.$store.getters["GROUPS/GROUPS"];
    },
    bindingOptions() {
      return this.variables;
    },
    subscriptionData() {
      return this.$store.getters["SUBSCRIPTIONS/SUBSCRIPTION_DATA"] || {};
    },
    globalCountersEnabled() {
      return this.subscriptionData.globalCountersEnabled === true;
    },
    dataTypeOptions() {
      const options = this.$store.getters["LABELS/VARIABLE_DATA_TYPES"] || [];
      if (this.globalCountersEnabled) {
        return options;
      }

      return options.filter(option => option.dataType !== "counter");
    },
    counters() {
      return this.$store.getters["COUNTERS/COUNTERS"];
    },
  },
  methods: {
    getSelectedCounter(counterId) {
      if (!counterId) return null;
      return this.counters.find(c => c.id === counterId) || null;
    },
    async getLabel() {
      this.loading = true;
      await this.getEnabledFeatures();
      await this.$store.dispatch("GROUPS/GET_AVAILABLE_GROUPS");
      await this.$store.dispatch("COUNTERS/GET_COUNTERS");

      this.currentLabel = await this.$store.dispatch(
        "LABELS/GET_LABEL_DETAILS",
        this.$route.params.id
      );
      const { type } = await this.$store.getters[
        "SUBSCRIPTIONS/SUBSCRIPTION_DATA"
      ];
      this.subscriptionType = type;

      this.labelname = this.currentLabel.name;
      this.numberOfIdenticalCopies = this.currentLabel.numberOfIdenticalCopies;
      this.useA4Pdf = this.currentLabel.useA4Pdf;

      this.variables = [...this.currentLabel.variables];
      this.variables.forEach(v => {
        v.dataType = v.propertyType;
        if (!this.globalCountersEnabled && v.dataType === "counter") {
          v.dataType = "default";
          v.counterId = null;
        }
        v["boundToName"] = !v.boundToId
          ? v.name
          : this.variables.filter(e => e.id === v.boundToId)[0].name;
        if (!Object.prototype.hasOwnProperty.call(v, 'counterId')) {
          v.counterId = v.counterId || null;
        }
      });

      this.groups = this.currentLabel.groups;
      this.existingGroups = this.groups.map(g => ({ ...g }));

      const data = await this.$store.dispatch("MEDIA_LIBRARY/GET_FILES");
      this.folders = data;

      this.loading = false;
    },
    gotoToArticleWithPresets() {
      const articleData = this.currentLabel.variables
        .filter(x => x.name.indexOf("meta_") != 0)
        .reduce((acc, curr) => acc + "&articleData=" + curr.name, "");

      const articleGroups = this.currentLabel.groups
        .map(g => g.id)
        .concat(this.groupsToBeAdded)
        .filter(groupid => !this.groupsToBeRemoved.includes(groupid))
        .reduce((acc, groupId) => acc + "&articleGroups=" + groupId, "");

      let presetData = `?name=Article%20for%20${
        this.labelname
      }${articleData}${articleGroups}`;
      this.$router.push(`/articles/new${presetData}`);
    },
    onFilesAdded(file) {
      this.file = file;
    },
    async uploadFiles() {
      try {
        this.loading = true;
        this.labelVariabelsChanged = true;
        const formData = new FormData();
        formData.append("variableFile", this.file);
        const updatedLabel = await this.$store.dispatch(
          "LABELS/CHANGE_BINARY",
          { id: this.currentLabel.labelId, form: formData }
        );
        this.currentLabel.variables = updatedLabel.variables;

        this.variables = [...this.currentLabel.variables];
        this.variables.forEach(v => {
          v["boundToName"] = !v.boundToId
            ? v.name
            : this.variables.filter(e => e.id === v.boundToId)[0].name;
        });

        this.labelVariabelsChanged = false;
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
    computeActivationStatus(past, lowercase) {
      if (past) {
        if (lowercase) {
          return this.currentLabel.disabled ? "activated" : "inactivated";
        } else {
          return this.currentLabel.disabled ? "Activated" : "Inactivated";
        }
      } else {
        if (lowercase) {
          return this.currentLabel.disabled ? "activate" : "inactivate";
        } else {
          return this.currentLabel.disabled ? "Activate" : "Inactivate";
        }
      }
    },
    async toggleActivateStatusOnLabel() {
      this.loading = true;
      try {
        if (this.currentLabel.disabled) {
          await this.$store.dispatch(
            "LABELS/ACTIVATE",
            this.currentLabel.labelId
          );
        } else {
          await this.$store.dispatch(
            "LABELS/INACTIVATE",
            this.currentLabel.labelId
          );
        }
        this.loading = false;
        this.modalInactivate = false;
        this.labelActiveStatusChanged = true;
        setTimeout(() => this.$router.push({ name: "labels" }), 1500);
      } catch (error) {
        this.loading = false;
        console.error(error);
      }
    },
    addPrinter(args) {
      this.printers[args.group.id] = args.printer.id;
    },
    removePrinter(args) {
      delete this.printers[args.group.id];
    },
    addGroup(group) {
      if (this.groupsToBeRemoved.find(g => g === group.id)) {
        this.groupsToBeRemoved = this.groupsToBeRemoved.filter(
          g => g !== group.id
        );
      } else {
        this.groupsToBeAdded.push(group.id);
      }
    },
    removeGroup(group) {
      if (this.existingGroups.find(g => g.id === group.id)) {
        this.groupsToBeRemoved.push(group.id);
      }

      if (this.groupsToBeAdded.find(g => g === group.id)) {
        this.groupsToBeAdded = this.groupsToBeAdded.filter(g => g !== group.id);
      }
    },
    forceRerender() {
      this.componentKey += 1;
    },
    validation() {
      return (
        this.labelname !== "" &&
        this.variables &&
        (this.file || !this.changeFile)
      );
    },
    hasChangesBeenMade() {
      return true;
    },
    updateBoundVariable(input, variable) {
      variable.boundToId = input.id;
      variable.boundToName = input.name;
      this.forceRerender();
    },
    updateVariableDataType(input, variable) {
      const requestedDataType = input && input.dataType ? input.dataType : "Unknown";
      variable.dataType =
        !this.globalCountersEnabled && requestedDataType === "counter"
          ? "default"
          : requestedDataType;
      if (variable.dataType !== "counter") {
        variable.counterId = null;
      }
      this.forceRerender();
    },
    async createLabel() {
      this.loading = true;
      let payload = {
        variables: [],
      };

      for (let i = 0; i < this.variables.length; i++) {
        const normalizedDataType =
          !this.globalCountersEnabled && this.variables[i].dataType === "counter"
            ? "default"
            : this.variables[i].dataType;
        payload.variables.push({
          variableId: this.variables[i].id,
          boundToId:
            this.variables[i].boundToId === this.variables[i].id
              ? undefined
              : this.variables[i].boundToId,
          dataType:
            normalizedDataType === null
              ? "Unknown"
              : normalizedDataType === undefined
              ? "Unknown"
              : normalizedDataType,
          editable: this.variables[i].editable,
          value: this.variables[i].value,
          counterId: normalizedDataType === 'counter'
            ? (this.variables[i].counterId || null)
            : null,
        });
      }
      const printers = Object.keys(this.printers).map(key => {
        return {
          groupId: parseInt(key),
          printerId: this.printers[key],
        };
      });
      await this.$store.dispatch("LABELS/CHANGE_VARIABLE_BINDING", payload);

      await this.$store.$api.put("/api/labels", {
        labelId: this.currentLabel.labelId,
        name: this.labelname,
        serialNumberSettings: {
          lastGeneratedValue: this.currentLabel.serialNumber
            ? this.currentLabel.serialNumber.lastGeneratedValue
            : null,
          serialNumberLength: this.currentLabel.serialNumber
            ? this.currentLabel.serialNumber.serialNumberLength
            : null,
        },
        numberOfIdenticalCopies: this.numberOfIdenticalCopies,
        useA4Pdf: this.useA4Pdf,
        useCounter: this.currentLabel.useCounter,
      });

      const { type } = this.$store.getters["SUBSCRIPTIONS/SUBSCRIPTION_DATA"];

      if (type && type !== "Free") {
        await this.$store.$api.put("/api/labels/printers", {
          labelId: this.currentLabel.labelId,
          printers: printers,
        });
      }

      await this.$store.$api.post("/api/labels/groups", {
        labelId: this.currentLabel.labelId,
        groupIds: this.groupsToBeAdded,
      });
      await this.$store.$api.post("/api/labels/groups/remove", {
        labelId: this.currentLabel.labelId,
        groupIds: this.groupsToBeRemoved,
      });

      this.loading = false;
    },
    async getEnabledFeatures() {
      const response = await this.$store.$api.get("/api/features");
      this.features = response.data.data;
    },
    openMediaLibraryModal(variable) {
      this.selectedVariable = variable;
      this.isMediaLibraryModalOpen = true;
    },
    saveMediaRefSelection(event) {
      this.selectedVariable.value = `media-ref:${event.folder}/${event.file}`;
      this.isMediaLibraryModalOpen = false;
    },
  },
};
</script>
